module.exports = __webpack_public_path__ + "static/media/white-icon.8aa7d918.svg";